import {
  DocumentGeneric,
  DocumentGenericAttributes,
  DocumentRelationships,
  DocumentStatus,
} from 'dashboard/models/document';
import { ApiModel } from 'lib/interfaces/api';

const PREVIEW_DATA_URL =
  'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBsRXhpZgAATU0AKgAAAAgAAwESAAMAAAABAAEAAAExAAIAAAAHAAAAModpAAQAAAABAAAAOgAAAABHb29nbGUAAAADoAEAAwAAAAEAAQAAoAIABAAAAAEAAAAJoAMABAAAAAEAAAAJAAAAAP/tADhQaG90b3Nob3AgMy4wADhCSU0EBAAAAAAAADhCSU0EJQAAAAAAENQdjNmPALIE6YAJmOz4Qn7/wAARCAAJAAkDAREAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9sAQwADAgIKCgoKDQsNCg0ICwgICA0KCwoKCgoNCg0KCgoKCAgLCgoNCAoKCggKCgoKCAgKCgoKCgoIDQ0KDQ4KCgoI/9sAQwEDBAQGBQYKBgYKDw0LDg0NDQ0NDw0NDQ0PDQ0NDQ0NDQ0NDQ8NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0N/90ABAAC/9oADAMBAAIRAxEAPwD7o8W+NktlOQGl2syoSF3EA4XcRgZOBz0JFfLVq6p7nfGDmzyX/hpjUP8AoGn/AMDIf8a8v69Ls/uOnk8z/9D6b/aa/wBba/8AXeL/ANGLX59jPigepRPRa0ND/9k=';
const createdAt = '2023-01-01T00:00:00.000Z';
const submittedAt = '2023-01-01T00:01:00.000Z';
const processedAt = submittedAt;

const DOCUMENT_GENERIC_FIXTURE: DocumentGeneric = {
  type: ApiModel.DocumentGeneric,
  id: 'doc_123',
  attributes: {
    filenames: ['image.jpg'],
    kind: 'proof_of_employment',
    status: DocumentStatus.Processed,
    'detected-language': 'en',
    pages: [
      {
        lines: [],
        faces: [],
        'page-angle': 0,
        'page-number': 0,
      },
    ],
    'created-at': createdAt,
    'submitted-at': submittedAt,
    'processed-at': processedAt,
    'redacted-at': null,
    files: [
      {
        'byte-size': 10000,
        'file-type': 'image/jpeg',
        filename: 'image.jpg',
        url: PREVIEW_DATA_URL,
      },
    ],
    'files-normalized': [],
    'extraction-responses': [],
    'insight-responses': [],
    fields: {},
    config: {
      extractions: [],
      insights: [],
    },
  },
  relationships: {
    inquiry: {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      data: null,
    },
  },
};

export function createPreviewDocumentGeneric(
  attributes?: Partial<DocumentGenericAttributes>,
  relationships?: Partial<DocumentRelationships>,
  id?: string,
): DocumentGeneric {
  return {
    attributes: {
      ...DOCUMENT_GENERIC_FIXTURE.attributes,
      ...attributes,
    },
    id: id || 'doc_123',
    type: ApiModel.DocumentGeneric,
    relationships: {
      ...DOCUMENT_GENERIC_FIXTURE.relationships,
      ...relationships,
    },
  };
}
